export default [  
  { none:  'none'    }, { black: '#000000' },  { grey:   '#888888' },
  { lime:  '#8cc800' }, { green: '#196d20' },  { orange: '#e36c09' }, 
  { red:   '#ff0000' }, { violet: '#5a00ff' }, { violet1:   '#76007c' }, 
  { cyan:  '#00d2ff' }, { blue:   '#0070c0' }, { navy:   '#22329a' },
];